import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {getStationInfo, getRegionDeviceList} from '@apis'

const DeviceManagementTime = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId, strongProjectId: projectId} = userInfo

    const [deviceManagementTimeData, setDeviceManagementTimeData] = useState([])
  
    async function queryStationInfo() {
      const params = {
        brokerId,
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = projectId ? await getStationInfo(params) : await getRegionDeviceList(params)
      if (res) {
        setDeviceManagementTimeData(res.data)
      }
    }
  
    useEffect(() => {
      queryStationInfo()
    }, [])
  
    return (
      <div className='ck-management-time'>
        <div className='title'>配电柜管理时间</div>
        <div className='management-item'>
          <div className='management-time'>
            {
              deviceManagementTimeData.map((item,index) => (
                <div className={`management-index ${index%2==0 ? "" : "active"}`}>
                  <div className='index-name'>{projectId ? item.name : item.sname}</div>
                  <div className='index-create'>创建时间 {item.createTime}</div>
                  <div className='index-end'>启停时间 {item.etime ? item.etime : '--'}</div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  })
)
export default DeviceManagementTime
